import { Reveal } from "./Reveal";

export default function EmptyState({ title = "Contenu à venir", message, dark = false, testId = "empty-state" }) {
  return (
    <Reveal>
      <div
        data-testid={testId}
        className={`border border-dashed px-8 py-16 sm:py-20 text-center ${
          dark ? "border-white/20 text-white" : "border-navy/20 text-navy"
        }`}
      >
        <span className="inline-block h-2 w-2 bg-rouge mb-6" />
        <p className="font-heading uppercase font-semibold tracking-tight text-2xl sm:text-3xl">{title}</p>
        <p className={`mt-3 text-sm max-w-md mx-auto ${dark ? "text-white/60" : "text-steel"}`}>
          {message || "Cette section sera alimentée prochainement par le club. Revenez bientôt."}
        </p>
      </div>
    </Reveal>
  );
}

export function ExampleBadge({ className = "" }) {
  return (
    <span
      data-testid="example-badge"
      className={`inline-flex items-center gap-1.5 bg-rouge text-white text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 ${className}`}
    >
      Exemple
    </span>
  );
}
